<mat-tab-group>
  <mat-tab label="Interaction Info">
    <div class="row m-0 mt-3">
      <div class="col-6">
        <mat-form-field>
          <input matInput [ngModel]="data.campaign ? data.campaign.name : 'Not Set'" placeholder="Campaign Name" disabled="disabled" />
        </mat-form-field>
        <mat-form-field>
          <input matInput [ngModel]="data.user ? data.user.name : 'Not Set'" placeholder="Integration Name" disabled="disabled" />
        </mat-form-field>
        <mat-form-field>
          <input matInput [value]="data.createdAt | date : 'dd MMM yyyy @ HH:mm a'" placeholder="Created At" disabled="disabled" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field>
          <input matInput [ngModel]="data.type" placeholder="Response Type" disabled="disabled" />
        </mat-form-field>
        <mat-form-field>
          <input matInput [ngModel]="data.responseCode" placeholder="Response Code" disabled="disabled" />
        </mat-form-field>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Raw Request">

    <div class="row m-0 mt-3">
      <div class="col-6">
        <mat-form-field>
          <input matInput [ngModel]="data.uri" placeholder="Request Uri" disabled="disabled" />
        </mat-form-field>
        <mat-form-field>
          <input matInput [ngModel]="data.ipAddress" placeholder="IP Address" disabled="disabled" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <pre placeholder="Request">Request Body<br/><code>{{data.request ? (data.request | json) : 'Request was Blank.'}}</code></pre>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Raw Response">
    <div class="response-wrapper mt-3">
      <pre placeholder="Response">Response Body<br/><code>{{data.response ? (data.response | json) : 'Response was Blank.'}}</code></pre>
    </div>
  </mat-tab>
</mat-tab-group>
